module.exports = "/*!\n * jQuery UI Selectable 1.13.3\n * https://jqueryui.com\n *\n * Copyright OpenJS Foundation and other contributors\n * Released under the MIT license.\n * https://jquery.org/license\n */\n.ui-selectable {\n\t-ms-touch-action: none;\n\ttouch-action: none;\n}\n.ui-selectable-helper {\n\tposition: absolute;\n\tz-index: 100;\n\tborder: 1px dotted black;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui/themes/base/selectable.css
// module id = 467
// module chunks = 0